// extracted by mini-css-extract-plugin
export default {"article":"ArticleCard_article__cNeq9","image":"ArticleCard_image__JmK-U","title":"ArticleCard_title__CUkhD","description":"ArticleCard_description__OT5yf"};